module.exports = __webpack_public_path__ + "static/image/service/pc/connect@3x.jpg?90769a16";